function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m50 45c1.103 0 2 .897 2 2h2c0-1.859-1.279-3.411-3-3.858v-2.142h-2v2h-3v4c0 2.206 1.794 4 4 4 1.103 0 2 .897 2 2v2h-2c-1.103 0-2-.897-2-2h-2c0 1.859 1.279 3.411 3 3.858v2.142h2v-2h3v-4c0-2.206-1.794-4-4-4-1.103 0-2-.897-2-2v-2z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m61 43.104v-24.104-1-4h-4v-8h-2v8h-4v-6h-2v6h-2v-8-1-4h-15.618l-2 4h-4.382v12.072c-.432-.046-.87-.072-1.313-.072-3.29 0-6.382 1.281-8.707 3.606l-.5.5c-2.652.792-4.48 3.227-4.48 6.017v9.877c0 2.206 1.794 4 4 4h1.739c.833 1.471 1.937 2.78 3.261 3.847v1.101c0 .83-.501 1.562-1.275 1.864l-9.562 3.719c-4.351 1.692-7.163 5.801-7.163 10.469v1h44v-1-.001c1.576.656 3.276 1.001 5 1.001 7.168 0 13-5.832 13-13 0-2.535-.74-4.894-2-6.896zm-23.927 8.13-4.073-1.584v-8.792c1.721-.447 3-1.999 3-3.858v-5h15v5.051c-.331-.026-.662-.051-1-.051-7.168 0-13 5.832-13 13 0 .413.035.824.073 1.234zm-10.073-5.286v-1.101c1.324-1.067 2.429-2.377 3.261-3.847h.739v7.872l-2.724-1.059c-.775-.302-1.276-1.035-1.276-1.865zm4.979-10.948h.021c1.103 0 2 .897 2 2s-.897 2-2 2h-.817c.464-1.268.738-2.614.796-4zm19.021-7v2h-15v-.687c0-.444-.026-.882-.072-1.313zm-10-2v-6h18v20.641c-1.646-1.583-3.706-2.733-6-3.278v-11.363zm18-8h-16v-2h16zm-26.382-15h12.382v2h-13.382zm-5.618 4h18v7h-4v4h-2v8h-3.466c-1.156-4.127-4.407-7.378-8.534-8.534zm-11.758 15.97.27-.067.882-.882c1.947-1.948 4.537-3.021 7.293-3.021 5.686 0 10.313 4.626 10.313 10.313v4.243c-.591-.344-1.268-.556-2-.556v-3h-1.758c-2.469 0-4.789-.961-6.535-2.707l-.707-.707-.707.707c-1.746 1.746-4.066 2.707-6.535 2.707h-1.758v3c-.732 0-1.409.212-2 .556v-6.433c0-1.968 1.333-3.675 3.242-4.153zm-1.242 16.03c-1.103 0-2-.897-2-2s.897-2 2-2h.021c.057 1.386.331 2.732.796 4zm2-4.544v-2.458c2.591-.055 5.037-.981 7-2.64 1.963 1.659 4.409 2.585 7 2.64v2.458c0 4.569-2.798 8.729-7 10.469-4.202-1.739-7-5.9-7-10.469zm6.648 12.481.352.131.352-.132c.578-.217 1.132-.478 1.665-.768.047.872.369 1.676.902 2.32l-.096.354c-.346 1.271-1.507 2.158-2.823 2.158s-2.477-.887-2.822-2.157l-.096-.354c.533-.644.855-1.448.902-2.321.533.291 1.086.552 1.664.769zm14.352 14.063v-4h-2v4h-24v-4h-2v4h-5.947c.363-3.415 2.572-6.337 5.834-7.605l9.484-3.688c.69 1.951 2.535 3.293 4.629 3.293s3.94-1.342 4.629-3.294l9.484 3.688c3.262 1.269 5.471 4.19 5.834 7.605h-5.947zm13 0c-1.843 0-3.643-.479-5.25-1.354-.667-3.163-2.659-5.873-5.514-7.454-.146-.72-.236-1.453-.236-2.192 0-6.065 4.935-11 11-11s11 4.935 11 11-4.935 11-11 11z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m43 22h14v2h-14z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m38 34h11v2h-11z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m29 9h2v2h-2z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m41 9h2v2h-2z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m33 9h2v2h-2z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m37 9h2v2h-2z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m33 13h2v2h-2z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m37 13h2v2h-2z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m29 13h2v2h-2z"
});

function SvgConsultation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultation);
export default __webpack_public_path__ + "static/media/consultation.3817cfc2.svg";
export { ForwardRef as ReactComponent };